import React from 'react';
import { Link } from 'react-router-dom';

const RightTop = () => {
    return (
        <>
            <div className="topRight_btnLabel">
               <Link to="/contact"> <input type="button" className="donate_button" value="Reach Us" 
                /></Link>
            </div>
        </>
    );
};

export default RightTop;